import React from "react"

function Footer() {
  return (
    <footer className="footer">
      <p>This just just a fake Amazon store</p>
    </footer>
  )
}

export default Footer
